class faqAccordions extends HTMLElement {
  constructor() {
    super();
    this.faqTabButtons = this.querySelectorAll('[js-faq-tab-button]');
    this.faqTabs = this.querySelectorAll('[js-faq-tab]');
    this.faqParentAccordions = this.querySelectorAll('[js-parent-accordion-details]');
    this.tabListener();
  }

  tabListener() {
    this.addEventListener('click', (event) => {
      const clickedTab = event.target.closest('[data-tab]')?.dataset.tab;

      if (clickedTab) {
        [...this.faqTabButtons, ...this.faqTabs].forEach(tab => {
          tab.classList.toggle('active', tab.dataset.tab === clickedTab);
        });
      }
    });

    const toggleParentAccordion = () => {
      const isDesktopWidth = window.innerWidth > 990;
      this.faqParentAccordions.forEach((accordion) => {
        accordion.open = isDesktopWidth;
      });
    }

    toggleParentAccordion();

    window.addEventListener('resize', () => toggleParentAccordion());
  }
}
customElements.define('faq-accordions', faqAccordions);
